'use client';

import { faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalContent } from '@pickleballinc/react-ui';
import { useState } from 'react';

import ConfirmationModal from '@/modules/league/new-components/header/ConfirmationModal';
import { useSubPlayer } from '@/modules/league/new-components/matches-components/hooks';
import { MatchesPlayers } from '@/modules/league/new-components/types';
import { useLoader } from '@/modules/league/PickleballLoaderContext';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
interface OpenEnterScoreModal {
  openModal: boolean;
  player: MatchesPlayers;
  setIsModalOpen: (show: boolean) => void;
  matchDateId: string;
}

const SubPlayerModal = ({
  openModal,
  player,
  setIsModalOpen,
  matchDateId,
}: OpenEnterScoreModal) => {
  const queryClient = useQueryClient();
  const [showNoticeSubPlayer, setShowNoticeSubPlayer] = useState(false);
  const [showNoticeRemoveSubPlayer, setShowNoticeRemoveSubPlayer] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState({
    firstName: '',
    lastName: '',
    userId: '',
    MatchDateID: '',
    PoolID: '',
    SessionTeamID_Out: '',
    UserID_Out: '',
    ScoreID: '',
  });
  const [subbedPlayer, setSubbedPlayer] = useState(1);
  const { mutate: saveSubPlayer } = useSubPlayer();

  const { setLoading } = useLoader();
  if (!openModal) return null;

  return (
    <Modal open={openModal}>
      <ModalContent
        className='flex w-[calc(100%-16px)] flex-col gap-4 !overflow-hidden !p-6 !outline-none md:max-w-[430px]'
        key={player?.T1a_UserID}
      >
        <div className='relative'>
          <h2 className='text-center text-base font-semibold leading-[22px] text-gray-900'>
            Group {player.DisplayMatchNumber} : Match {player?.DisplayMatchNumber}
          </h2>
          <div className='flex flex-col pt-2'>
            <p>Select the player who needs a sub and save</p>
            <div className='mt-4 hidden w-full border-t-[0.5px] border-gray-200 px-2 md:block' />
          </div>
          <div
            className='absolute -right-2 top-0 flex size-6 items-center justify-center rounded-md border border-solid border-gray-300 bg-white p-1 hover:cursor-pointer hover:bg-gray-100'
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faX} className='text-gray-400' height={20} />
          </div>
        </div>
        <div className='flex text-left text-base font-semibold text-gray-900'>Players</div>
        <div className='flex w-full flex-col gap-1.5 pb-4'>
          {/* Players Section */}
          <div className='items-left flex flex-col gap-3'>
            <div className='flex flex-col justify-start gap-2'>
              <div className='flex flex-row'>
                <Button
                  variant='secondary'
                  className={`!rounded-full p-2 !text-xs font-semibold uppercase md:mb-1 md:!text-sm
							${player?.T1a_SubbedPlayer === null ? '!bg-leagues-500 hover:!bg-leagues-700 !text-white md:!px-4' : '!bg-transparent !text-gray-900 !underline md:!px-3'} `}
                  onClick={() => {
                    setSelectedPlayer({
                      firstName: player?.T1a_FirstName,
                      lastName: player?.T1a_LastName,
                      userId: player?.T1a_UserID,
                      UserID_Out: player?.T1a_UserID,
                      MatchDateID: matchDateId,
                      PoolID: player?.PoolID,
                      SessionTeamID_Out: player?.T1a_SessionTeamID,
                      ScoreID: player?.ScoreID,
                    });
                    if (player?.T1a_SubbedPlayer === null) {
                      setSubbedPlayer(1);
                    } else {
                      setSubbedPlayer(0);
                    }
                    if (player?.T1a_SubbedPlayer === null) {
                      setShowNoticeSubPlayer(true);
                    } else {
                      setShowNoticeRemoveSubPlayer(true);
                    }
                  }}
                >
                  {player?.T1a_SubbedPlayer === null ? 'Sub Player' : 'Remove Sub'}
                </Button>
                <span className='line-clamp-3 flex items-center pb-1 pl-4 text-sm md:text-base'>
                  {player?.T1a_SubbedPlayer === null
                    ? `${player?.T1a_FirstName} ${player?.T1a_LastName}`
                    : `SUB for ${player?.T1a_SubbedPlayer}`}
                </span>
              </div>
              <div className='justify-left flex flex-col'>
                <div className='flex flex-row'>
                  <Button
                    variant='secondary'
                    className={`!rounded-full p-2 !text-xs font-semibold uppercase md:mb-1 hover:text-none md:!text-sm
							${player?.T1b_SubbedPlayer === null ? '!bg-leagues-500 hover:!bg-leagues-700 !text-white md:!px-4' : '!bg-transparent !text-gray-900 !underline md:!px-3'} `}
                    onClick={() => {
                      setSelectedPlayer({
                        firstName: player?.T1b_FirstName,
                        lastName: player?.T1b_LastName,
                        userId: player?.T1b_UserID,
                        MatchDateID: matchDateId,
                        PoolID: player?.PoolID,
                        SessionTeamID_Out: player?.T1b_SessionTeamID || player?.T1a_SessionTeamID,
                        UserID_Out: player?.T1b_UserID,
                        ScoreID: player?.ScoreID,
                      });
                      if (player?.T1b_SubbedPlayer === null) {
                        setSubbedPlayer(1);
                      } else {
                        setSubbedPlayer(0);
                      }

                      if (player?.T1a_SubbedPlayer === null) {
                        setShowNoticeSubPlayer(true);
                      } else {
                        setShowNoticeRemoveSubPlayer(true);
                      }
                    }}
                  >
                    {player?.T1b_SubbedPlayer === null ? 'Sub Player' : 'Remove Sub'}
                  </Button>
                  <span className='line-clamp-3 flex items-center pb-1 pl-4 text-sm md:text-base'>
                    {player?.T1b_SubbedPlayer === null
                      ? `${player?.T1b_FirstName} ${player?.T1b_LastName}`
                      : `SUB for ${player?.T1b_SubbedPlayer}`}
                  </span>
                </div>
              </div>
              <div className='justify-left flex flex-col'>
                <div className='flex flex-row'>
                  <Button
                    variant='secondary'
                    className={`!rounded-full p-2 !text-xs font-semibold uppercase  md:mb-1 md:!text-sm
							${player?.T2a_SubbedPlayer === null ? '!bg-leagues-500 hover:!bg-leagues-700 !text-white md:!px-4' : '!bg-transparent !text-gray-900 !underline md:!px-3'} `}
                    onClick={() => {
                      setSelectedPlayer({
                        firstName: player?.T2a_FirstName,
                        lastName: player?.T2a_LastName,
                        userId: player?.T2a_UserID,
                        MatchDateID: matchDateId,
                        UserID_Out: player?.T2a_UserID,
                        PoolID: player?.PoolID,
                        SessionTeamID_Out: player?.T2a_SessionTeamID,
                        ScoreID: player?.ScoreID,
                      });
                      if (player?.T2a_SubbedPlayer === null) {
                        setSubbedPlayer(1);
                      } else {
                        setSubbedPlayer(0);
                      }

                      if (player?.T1a_SubbedPlayer === null) {
                        setShowNoticeSubPlayer(true);
                      } else {
                        setShowNoticeRemoveSubPlayer(true);
                      }
                    }}
                  >
                    {player?.T2a_SubbedPlayer === null ? 'Sub Player' : 'Remove Sub'}
                  </Button>
                  <span className='line-clamp-3 flex items-center pb-1 pl-4 text-sm md:text-base'>
                    {player?.T2a_SubbedPlayer === null
                      ? `${player?.T2a_FirstName} ${player?.T2a_LastName}`
                      : `SUB for ${player?.T2a_SubbedPlayer}`}
                  </span>
                </div>
              </div>
              <div className='justify-left flex flex-col'>
                <div className='flex flex-row'>
                  <Button
                    variant='secondary'
                    className={`!rounded-full p-2 !text-xs font-semibold uppercase  md:mb-1 md:!text-sm
							${player?.T2b_SubbedPlayer === null ? '!bg-leagues-500 hover:!bg-leagues-700 !text-white md:!px-4' : '!bg-transparent !text-gray-900 !underline md:!px-3'} `}
                    onClick={() => {
                      setSelectedPlayer({
                        firstName: player?.T2b_FirstName,
                        lastName: player?.T2b_LastName,
                        userId: player?.T2b_UserID,
                        MatchDateID: matchDateId,
                        PoolID: player?.PoolID,
                        UserID_Out: player?.T2b_UserID,
                        SessionTeamID_Out: player?.T2b_SessionTeamID || player?.T2a_SessionTeamID,
                        ScoreID: player?.ScoreID,
                      });
                      if (player?.T2b_SubbedPlayer === null) {
                        setSubbedPlayer(1);
                      } else {
                        setSubbedPlayer(0);
                      }

                      if (player?.T1a_SubbedPlayer === null) {
                        setShowNoticeSubPlayer(true);
                      } else {
                        setShowNoticeRemoveSubPlayer(true);
                      }
                    }}
                  >
                    {player?.T2b_SubbedPlayer === null ? 'Sub Player' : 'Remove Sub'}
                  </Button>
                  <span className='line-clamp-3 flex items-center pb-1 pl-4 text-sm md:text-base'>
                    {player?.T2b_SubbedPlayer === null
                      ? `${player?.T2b_FirstName} ${player?.T2b_LastName}`
                      : `SUB for ${player?.T2b_SubbedPlayer}`}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmationModal
          open={showNoticeSubPlayer}
          onClose={() => setShowNoticeSubPlayer(false)}
          onConfirm={() => {
            setLoading(true);
            saveSubPlayer(
              { matchDateId: matchDateId, player: selectedPlayer, subbedPlayer: subbedPlayer },
              {
                onSuccess: (data) => {
                  if (data.message) {
                    toast.success(data.message);
                  }
                },
                onError: () => {
                  toast.error('Failed to save a sub player.');
                  setLoading(false);
                },
              }
            );
            queryClient.invalidateQueries(['league_matches']);
            setShowNoticeSubPlayer(false);
            setIsModalOpen(false);
          }}
          title='Are you sure?'
          message={`This will replace ${selectedPlayer.firstName} ${selectedPlayer.lastName} with a sub player.`}
        />
        <ConfirmationModal
          open={showNoticeRemoveSubPlayer}
          onClose={() => setShowNoticeRemoveSubPlayer(false)}
          onConfirm={() => {
            setLoading(true);
            saveSubPlayer(
              { matchDateId: matchDateId, player: selectedPlayer, subbedPlayer: subbedPlayer },
              {
                onSuccess: (data) => {
                  if (data.message) {
                    toast.success(data.message);
                  }
                },
                onError: () => {
                  toast.error('Failed to remove a sub player.');
                  setLoading(false);
                },
              }
            );
            queryClient.invalidateQueries(['league_matches']);
            setShowNoticeRemoveSubPlayer(false);
            setIsModalOpen(false);
          }}
          title='Are you sure?'
          message={`This will replace the sub with the original player.`}
        />
      </ModalContent>
    </Modal>
  );
};

export default SubPlayerModal;
